import { render, staticRenderFns } from "./notice_detail.vue?vue&type=template&id=71f53c2d&scoped=true"
import script from "./notice_detail.vue?vue&type=script&lang=js"
export * from "./notice_detail.vue?vue&type=script&lang=js"
import style0 from "./notice_detail.vue?vue&type=style&index=0&id=71f53c2d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f53c2d",
  null
  
)

export default component.exports